import { serviceApi } from '@hydrogen/elements.core.rest.transport';
import type { GetGlobalSettingByGroupAndKey } from './types';

export const getGlobalSettingByGroupAndKey = ({
    group,
    key,
}: GetGlobalSettingByGroupAndKey) => serviceApi().get(`/v1.0/settings/${group}/${key}?useApplicationToken=true`);
